module.exports = __webpack_public_path__ + "img/vencasa-snap.75695dee.png";